<script setup lang="ts">
import type { ClassValue } from 'tailwind-variants';
import { IconDotsVertical } from '@tabler/icons-vue';
import DropdownMenu, { type DropdownItemEntry } from './DropdownMenu.vue';
import MsButton from '@/components/ui/button/MsButton.vue';

type Side = 'top' | 'right' | 'bottom' | 'left';
type Align = 'start' | 'center' | 'end';

withDefaults(defineProps<{
    items?: DropdownItemEntry[];
    label?: string;
    side?: Side;
    align?: Align;
    sideOffset?: number;
    contentClass?: ClassValue;
}>(), {
    items: () => [],
    label: undefined,
    side: 'bottom',
    align: 'end',
    sideOffset: 4,
    contentClass: undefined,
});
</script>

<template>
    <DropdownMenu
        :items="items"
        :side="side"
        :align="align"
        :side-offset="sideOffset"
        :content-class="contentClass"
    >
        <template #trigger>
            <MsButton
                color="neutral"
                :icon="IconDotsVertical"
                :label="label"
                :square="!label"
            />
        </template>

        <template
            v-if="$slots.item"
            #item="slotProps"
        >
            <slot
                name="item"
                v-bind="slotProps"
            />
        </template>
    </DropdownMenu>
</template>
